(function () {
    'use strict';

    angular.module('swif.openbase')
    .config(route)
    .factory('swifOpenbaseEquipmentCategoryService', swifOpenbaseEquipmentCategoryService)
    .controller('OpenbaseEquipmentCategoriesController', OpenbaseEquipmentCategoriesController)
    .controller('OpenbaseEquipmentCategoryController', OpenbaseEquipmentCategoryController);

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/equipment_categories/table_view', {
            templateUrl: 'partials/openbase/equipment_categories_table_view.html',
            controller: 'OpenbaseEquipmentCategoriesController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }

    function swifOpenbaseEquipmentCategoryService(swif) {
        'ngInject';
        var service = {};
        service.collection_id = 'equipment_category';
        service.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.collections.createOrUpdate(
                service.collection_id, 'equipment_category',
                filter, {location: true})
            .then(function (collection) {
                collection.currentFilter.limit = 0;
                return collection;
            });
        };
        service.getCollection = function () {
            return swif.collections.getCollection(service.collection_id);
        };
        service.callback = function (error, data) {
            var collection = service.getCollection();
            if (collection) {
                collection.defaultActionCallback(error, data);
            }
        };
        service.preValidate = function (data) {
            var collection = service.getCollection();
            if (collection) {
                return collection.preValidate(data);
            }
        };
        service.preModal = function (data) {
            var collection = service.getCollection();
            if (collection) {
                collection.preModal(data);
            }
        };

        return service;
    }



    function OpenbaseEquipmentCategoriesController($scope, swif, swifOpenbaseEquipmentCategoryService) {
        'ngInject';
        $scope.modules = swif.module.modules;
        swifOpenbaseEquipmentCategoryService.createCollection().then(function (collection) {
            $scope.equipmentCategories = collection;
        });
        $scope.callback = swifOpenbaseEquipmentCategoryService.callback;
        $scope.preValidate = swifOpenbaseEquipmentCategoryService.preValidate;
        $scope.preModal = swifOpenbaseEquipmentCategoryService.preModal;
    }


    function OpenbaseEquipmentCategoryController($scope, swif) {
        'ngInject';
        $scope.modules = swif.module.modules;
        $scope.filters = {
            supplier: {}
        };

        if (!$scope.model.is_equipment && ($scope.model.is_vehicle || $scope.model.is_key || $scope.model.is_fluid_meter || $scope.model.is_streetlight)) {
            $scope.model.is_equipment = false;
        } else {
            $scope.model.is_equipment = true;
        }
        if (!$scope.model.is_vehicle) {
            $scope.model.is_vehicle = false;
        }
        if (!$scope.model.is_key) {
            $scope.model.is_key = false;
        }
        if (!$scope.model.is_fluid_meter) {
            $scope.model.is_fluid_meter = false;
        }
        if (!$scope.model.is_streetlight) {
            $scope.model.is_streetlight = false;
        }

        $scope.setCatType = function(type) {
            $scope.model.is_equipment = false;
            $scope.model.is_vehicle = false;
            $scope.model.is_key = false;
            $scope.model.is_fluid_meter = false;
            $scope.model.is_streetlight = false;
            switch(type) {
                case 'equipment':
                    $scope.model.is_equipment = true;
                    break;
                case 'vehicle':
                    $scope.model.is_vehicle = true;
                    break;
                case 'key':
                    $scope.model.is_key = true;
                    break;
                case 'fluid':
                    $scope.model.is_fluid_meter = true;
                    break;
                case 'public_lightning':
                    $scope.model.is_streetlight = true;
                    break;
                default:
                    $scope.model.is_equipment = true;
            }
        }
    }

})();
